// LEGO color pricing (estimated)
export const colorPrices: { [key: number]: number } = {
  0: 0.12, // White
  1: 0.15, // Dark Stone Gray
  2: 0.18, // Bright Red
  3: 0.16, // Dark Green
  4: 0.17, // Earth Blue
  5: 0.14, // Bright Yellow
  6: 0.2, // Flame Orangey Yellow
  7: 0.25, // Medium Lavender
  8: 0.19, // Reddish Brown
  9: 0.13, // Light Stone Gray
  10: 0.15, // Medium Stone Gray
  11: 0.22, // Cool Yellow
  12: 0.18, // Silver
  13: 0.21, // Orange
  14: 0.23, // Sand Blue
  15: 0.2, // Sand Yellow
  16: 0.26, // Medium Azur
  17: 0.17, // Bright Green
  18: 0.19, // Bright Yellowish Green
  19: 0.24, // Earth Green
  20: 0.18, // Nougat
};

// Brick type pricing multiplier
export const brickTypeMultipliers: { [key: string]: number } = {
  "1x1": 1.0,
  "1x2": 1.8,
  "2x2": 3.2,
  "2x4": 5.5,
  "1x3": 2.5,
  "1x4": 3.2,
  "2x3": 4.0,
  "2x6": 7.5,
  "2x8": 9.0,
  "4x4": 10.0,
  "4x6": 14.0,
  "4x8": 18.0,
  "1x1p": 0.8,
  "1x2p": 1.2,
  "2x2p": 2.0,
  "2x4p": 3.5,
};

export const getColorHex = (colorName: string): string => {
  const colors: { [key: string]: string } = {
    White: "#FFFFFF",
    "Dark Stone Gray": "#1B2A34",
    "Bright Red": "#C4281C",
    "Dark Green": "#008F00",
    "Earth Blue": "#0054A6",
    "Bright Yellow": "#FFF300",
    "Flame Orangey Yellow": "#F15A22",
    "Medium Lavender": "#7B2E7A",
    "Reddish Brown": "#7B4B31",
    "Light Stone Gray": "#C7D5D3",
    "Medium Stone Gray": "#696969",
    "Cool Yellow": "#009E9E",
    Silver: "#8C8C8C",
    Orange: "#FF8000",
    "Sand Blue": "#4C92C1",
    "Sand Yellow": "#EACE93",
    "Medium Azur": "#9B59B5",
    "Bright Green": "#469947",
    "Bright Yellowish Green": "#9BCD37",
    "Earth Green": "#274691",
    Nougat: "#EEC4B6",
  };
  return colors[colorName] || "#CCCCCC";
};
